import { useFoldersQueryReload } from './use-folders-query';

export const withFolderQueryReload = (Component: React.ComponentType<any>) => (props: any) => {
  const reloadFolders = useFoldersQueryReload();
  return (
    <Component
      {...props}
      reloadFolders={reloadFolders}
    />
  );
};
